import QuoteIcon from '@icons/quote.svg?react';
import { generateKey } from '@utils';
import Styled from './QuoteCard.styled';

const EMPHASIS_PATTERN = /(\*\*.+?\*\*)/g;

interface Props {
  text: string;
}

function renderText(text: string) {
  return text
    .split(EMPHASIS_PATTERN)
    .filter(Boolean)
    .map((segment, index) => {
      const key = generateKey(`quote-${index}-${segment}`);

      if (segment.startsWith('**') && segment.endsWith('**')) {
        return (
          <Styled.Emphasis key={key}>
            {segment.slice(2, -2)}
          </Styled.Emphasis>
        );
      }

      return <span key={key}>{segment}</span>;
    });
}

function QuoteCard({ text }: Props) {
  return (
    <Styled.Root>
      <QuoteIcon aria-hidden height={15} width={21} />
      <Styled.Body>{renderText(text)}</Styled.Body>
    </Styled.Root>
  );
}

export default QuoteCard;
